import { environment } from '../../environments/environment';

export const apiBase: any = {
    apiUrl: environment.baseURL,
    imageUrl: environment.imageURL,
    websiteURL: environment.websiteURL,
    login: "user/login",
    user: "user",
    gallery: "gallery",
    getCategoryWisegallery: "gallery/",
    galleryActive: "gallery/SelectActive",
    gallerycategory: "gallerycategory",
    getActiveCategory: "gallerycategory/active",
    getCoursesCategory: "coursescategory",
    getSubCategoryCourses: "coursessubcategory/active/",
    getCoursesSubCategory: "coursessubcategory",
    subCategoryCoursesActiveDeactive: "coursessubcategory",
    getCourses: "courses/active/",
    coursesActiveDeactive: "courses",
    courses: "courses",
    coursesinquiry: "coursesinquiry",
    getCoursesCategoryActive: "coursescategory/active",
    getDatewiseCoursesInquiry: "coursesinquiry/SelectByDate",
    getBanners: "banner",
    bannerStatus: "banner",
    activeBanners: "banner/SelectActive",
};